import type { BoxProps } from '@packages/shared';
import { Box } from '@packages/shared';

export interface HintPanelProps extends BoxProps {
  header?: React.ReactNode;
  children: React.ReactNode;
}

export const HintPanel: React.FC<HintPanelProps> = ({ header, children, ...props }) => (
  <Box
    {...props}
    sx={{
      position: 'relative',
      textAlign: 'center',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'grey.main',
      borderRadius: '3px',
      ...props.sx,
    }}
  >
    {header && (
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          p: '0 0.5rem',
          bgcolor: 'common.white',
        }}
      >
        {header}
      </Box>
    )}
    <Box sx={{ p: 1 }}>{children}</Box>
  </Box>
);
